import type { LegalDocumentSlug } from "./types";

/**
 * NP-582 — slug and label for each hosted document, and nothing else.
 *
 * Deliberately content-free and separate from `documents.ts`: `LegalFooterLinks`
 * renders on EVERY page, and importing the registry there would pull the full text of
 * all three documents — the Privacy Policy alone is ~32KB — into the main bundle,
 * defeating the lazy route that exists to keep them out of it.
 *
 * The labels are duplicated from each document's `title` for that reason.
 * `np582-hosted-legal-pages.test.tsx` pins them to each other so the footer can never
 * advertise a different name than the page shows.
 */
export const LEGAL_LINKS: ReadonlyArray<{ slug: LegalDocumentSlug; label: string }> = [
  { slug: "terms", label: "Terms of Use" },
  { slug: "privacy", label: "Privacy Policy" },
  { slug: "disclaimer", label: "Disclaimer" },
];

const SLUGS: ReadonlySet<string> = new Set(LEGAL_LINKS.map((link) => link.slug));

/** Route path for a document, so the footer and the route never disagree. */
export const legalDocumentPath = (slug: LegalDocumentSlug) => `/legal/${slug}`;

export const isLegalDocumentSlug = (value: string | undefined): value is LegalDocumentSlug =>
  value !== undefined && SLUGS.has(value);
